import React, { useCallback } from 'react';
import {
  Navbar, Nav, NavDropdown,
} from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  DASHBOARD, PROFILE,
} from 'constants/routes';
import { useDispatch, useSelector } from 'react-redux';
import Storage from 'utils/Storage';
import {
  logoutUser, selectUserAccount, updateUserAccount,
} from 'store/User';
import AuthService from 'services/api/Auth';
import handlePromise from 'utils/Promise';
import { isSsoEnabled } from 'utils/authMode';
import _ from 'lodash';
import { Profile } from 'types/User';

import { PromotionSummary } from 'types/Project';
import Sidebar from '../Sidebar/Sidebar';

function Header( {
  accounts,
  profile,
  promotionsSummary,
}:
{
  accounts: any[];
  profile?: Profile,
  promotionsSummary:PromotionSummary[]
} ) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userAccountId = useSelector( selectUserAccount );

  const userAccount = _.find( accounts, { cuentaDeInversionId: userAccountId } );
  const myAccounts: any = _.filter( accounts, { miInversion: true } );
  const otherAccounts: any = _.filter( accounts, { miInversion: false } );

  const logout = useCallback( async () => {
    const accessToken = Storage.get( 'grupoimpar:token' );
    if ( isSsoEnabled() && accessToken ) {
      await handlePromise( AuthService.ssoLogout( {
        accessToken,
        revokeAll: false,
      } ) );
    }
    dispatch( logoutUser() );
    Storage.clear( 'grupoimpar:token' );
    Storage.clear( 'grupoimpar:refreshToken' );
  }, [dispatch] );

  return (
    <Navbar expand="md">
      <Navbar.Toggle aria-controls="offcanvasNavbar-expand-sm" />

      <div className="d-flex align-items-center">
        {!!myAccounts && !!myAccounts.length && (
        <Nav className="nav__item-investment d-block">
          <NavDropdown
            title={userAccount?.nameCuentadeInversion}
            id="investments-nav-dropdown"
          >
            {myAccounts.map( ( item: any ) => {
              if ( item.cuentaDeInversionId !== userAccountId ) {
                return (
                  <NavDropdown.Item
                    key={item.cuentaDeInversionId}
                    onClick={() => {
                      dispatch( updateUserAccount( item.cuentaDeInversionId ) );
                      navigate( `${DASHBOARD}`, { replace: true } );
                    }}
                  >
                    {item.nameCuentadeInversion}
                  </NavDropdown.Item>
                );
              }
              return null;
            } )}
            {otherAccounts.length > 0 && ( <NavDropdown.Divider /> )}
            {otherAccounts.map( ( item: any ) => {
              if ( item.cuentaDeInversionId !== userAccountId ) {
                return (
                  <NavDropdown.Item
                    key={item.cuentaDeInversionId}
                    onClick={() => {
                      dispatch( updateUserAccount( item.cuentaDeInversionId ) );
                      navigate( `${DASHBOARD}`, { replace: true } );
                    }}
                  >
                    {item.nameCuentadeInversion}
                  </NavDropdown.Item>
                );
              }
              return null;
            } )}
          </NavDropdown>
        </Nav>
        )}

        <Nav className="nav__item-user">
          <NavDropdown
            title={(
              <>
                {profile?.photo ? ( <img src={profile?.photo} alt="" className="rounded-circle avatar--xxs me-sm-2" /> )
                  : (
                    <i className="icon-user user-avatar me-sm-2" />
                  )}
                <span className="d-none d-sm-block">
                  {`${profile?.firstName || ''} ${profile?.lastName || ''}`}
                </span>
              </>
              )}
            id="user-nav-dropdown"
          >
            <NavDropdown.Item
              as={NavLink}
              to={PROFILE}
            >
              {t( 'personalArea' )}
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item
              className="text-primary"
              onClick={logout}
            >
              {t( 'closeSession' )}
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </div>

      <Navbar.Offcanvas
        placement="start"
        id="offcanvasNavbar-expand-sm"
        aria-labelledby="offcanvasNavbarLabel-expand-sm"
      >
        <Sidebar promotionsSummary={promotionsSummary} />
      </Navbar.Offcanvas>
    </Navbar>
  );
}

export default Header;
